export const attractionQueryKeys = {
  all: ['experiences', 'attractions'] as const,
  lists: () => [...attractionQueryKeys.all, 'list'] as const,
  list: (filters?: Record<string, unknown>) => [...attractionQueryKeys.lists(), filters] as const,
  cities: () => [...attractionQueryKeys.all, 'cities'] as const,
  filterOptions: (countryCode?: string, state?: string, province?: string) =>
    [...attractionQueryKeys.all, 'filter-options', countryCode, state, province] as const,
  stats: (filters?: Record<string, unknown>) => [...attractionQueryKeys.all, 'stats', filters] as const,
  details: () => [...attractionQueryKeys.all, 'detail'] as const,
  detail: (id: string) => [...attractionQueryKeys.details(), id] as const,
  offers: (id: string) => [...attractionQueryKeys.detail(id), 'offers'] as const,
  images: (id: string) => [...attractionQueryKeys.detail(id), 'images'] as const,
};
